/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));

var Sphere = __ol__.Sphere;


var EPSG_4326 = 'EPSG:4326';
var EPSG_3857 = 'EPSG:3857';
/**
 * @type {number} Default map max zoom
 */
var MAX_ZOOM = 28;
/**
 * @type {number} Default map min zoom
 */
var MIN_ZOOM = 0;
/**
 * @type {number} Default tile size
 */
var TILE_SIZE = 256;
/**
 * @type {string}
 */
var TILE_FORMAT = 'png';
/**
 * @type {number} Default zoom factor
 */
var ZOOM_FACTOR = 2;
/**
 * @type {number}
 */
var CACHE_SIZE = 2048;
/**
 * @type {number}
 */
var PIXEL_RATIO = 1;
/**
 * @type {string}
 */
var CROSS_ORIGIN = 'anonymous';
/**
 * @type {number}
 */
var REPROJ_ERR_THRESHOLD = 0.5;
/**
 * @type {number} Earth radius in meters
 */
var EARTH_RADIUS = 6378137;
var WGS84_SPHERE = new Sphere(EARTH_RADIUS);

var RENDERER_TYPE = {
  CANVAS: 'canvas',
  WEBGL: 'webgl'
};

var GEOMETRY_TYPE = {
  POINT: 'Point',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon',
  MULTI_POINT: 'MultiPoint',
  MULTI_LINE_STRING: 'MultiLineString',
  MULTI_POLYGON: 'MultiPolygon',
  GEOMETRY_COLLECTION: 'GeometryCollection',
  CIRCLE: 'Circle'
};

var EXTENT_CORNER = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right'
};

var PROJ_UNIT = {
  DEGREES: 'degrees',
  FEET: 'ft',
  METERS: 'm',
  PIXELS: 'pixels',
  TILE_PIXELS: 'tile-pixels',
  USFEET: 'us-ft'
};

var OVERLAY_POSITIONING = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
  CENTER_LEFT: 'center-left',
  CENTER_CENTER: 'center-center',
  CENTER_RIGHT: 'center-right',
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right'

  /**
   * @type {string} Default WMS version
   */
};var WMS_VERSION = '1.3.0';
var WMS_SERVER_TYPE = {
  CARMENTA_SERVER: 'carmentaserver',
  GEOSERVER: 'geoserver',
  MAPSERVER: 'mapserver',
  QGIS: 'qgis'
};

var WMTS_VERSION = '1.0.0';
var WMTS_REQUEST_ENCODING = 'KVP';
var WMTS_FORMAT = 'image/jpeg';
var LAYER_PROP = 'layer';

exports.EPSG_4326 = EPSG_4326;
exports.EPSG_3857 = EPSG_3857;
exports.MAX_ZOOM = MAX_ZOOM;
exports.MIN_ZOOM = MIN_ZOOM;
exports.TILE_SIZE = TILE_SIZE;
exports.TILE_FORMAT = TILE_FORMAT;
exports.ZOOM_FACTOR = ZOOM_FACTOR;
exports.CACHE_SIZE = CACHE_SIZE;
exports.PIXEL_RATIO = PIXEL_RATIO;
exports.CROSS_ORIGIN = CROSS_ORIGIN;
exports.REPROJ_ERR_THRESHOLD = REPROJ_ERR_THRESHOLD;
exports.EARTH_RADIUS = EARTH_RADIUS;
exports.WGS84_SPHERE = WGS84_SPHERE;
exports.RENDERER_TYPE = RENDERER_TYPE;
exports.GEOMETRY_TYPE = GEOMETRY_TYPE;
exports.EXTENT_CORNER = EXTENT_CORNER;
exports.PROJ_UNIT = PROJ_UNIT;
exports.OVERLAY_POSITIONING = OVERLAY_POSITIONING;
exports.WMS_VERSION = WMS_VERSION;
exports.WMS_SERVER_TYPE = WMS_SERVER_TYPE;
exports.WMTS_VERSION = WMTS_VERSION;
exports.WMTS_REQUEST_ENCODING = WMTS_REQUEST_ENCODING;
exports.WMTS_FORMAT = WMTS_FORMAT;
exports.LAYER_PROP = LAYER_PROP;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/ol-ext/consts.js
// module id = 23
// module chunks = 1